(function() {

    const WebFont = require('webfontloader');

    WebFont.load({

        google: {
            families: ['Noto+Sans:400,700:latin-ext']
        }
    });
})();

